export default {
  landing: {
    title: "Régie Connect",
    subtitle: "Solución de gestión para profesionales de la iluminación LED",
    admin: "Administración",
    adminDesc: "Gestión de stock LED y operaciones",
    partner: "Socio",
    partnerDesc: "Espacio socio",
    installer: "Instalador",
    installerDesc: "Agenda de citas",
    commercial: "Comercial",
    commercialDesc: "Planning y documentos",
    connect: "Iniciar sesión",
    welcome: "Bienvenido a Régie Connect",
  },
  legal: {
    mentions: "Aviso legal",
    cgu: "Términos de uso",
    confidentiality: "Privacidad",
    back: "Volver",
  },
  paywall: {
    title: "Suscripción requerida",
    description: "Su período de prueba ha terminado. Elija un plan para seguir accediendo a su panel de administración.",
    choosePlan: "Elegir un plan",
    redirecting: "Redirigiendo…",
    secureNote: "Pago seguro vía Stripe. En modo prueba use la tarjeta 4242 4242 4242 4242.",
    logout: "Cerrar sesión",
  },
  auth: {
    accessAdmin: "Acceso administración",
    accessPartner: "Acceso socio",
    accessInstaller: "Acceso instalador",
    accessCommercial: "Acceso comercial",
    createAccount: "Crear cuenta",
    emailPlaceholder: "Correo electrónico",
    passwordPlaceholder: "Contraseña",
    namePlaceholder: "Nombre completo",
    codePlaceholder: "CÓDIGO DE ACCESO",
    login: "Iniciar sesión",
    register: "Registrarse",
    alreadyHaveAccount: "Ya tengo una cuenta",
    createAdminAccount: "Crear cuenta de administrador",
    forgotPassword: "¿Olvidó su contraseña?",
    forgotCode: "¿Código olvidado?",
    mfaTitle: "Autenticación en dos pasos",
    mfaDescription: "Introduzca el código de 6 dígitos de su aplicación",
    mfaVerify: "Verificar",
    mfaBack: "Volver",
    secureAccess: "Conexión segura",
    invalidLoginCredentials: "Correo o contraseña incorrectos.",
    invalidLoginCredentialsLocal: "En local: compruebe que esta cuenta exista en su proyecto Supabase (Dashboard → Authentication) o créela con « Crear cuenta administrador ».",
    invalidRole: "Rol no válido",
    allFieldsRequired: "Todos los campos son obligatorios",
    emailPasswordRequired: "Email y contraseña requeridos",
    accessCodeRequired: "Código de acceso requerido",
    mfaCodeRequired: "Introduzca el código de 6 dígitos de su aplicación",
    forgotPasswordTitle: "¿Olvidó la contraseña?",
    forgotPasswordDesc: "Introduzca su email para recibir un enlace de restablecimiento",
    emailRequired: "Email requerido",
    sendLink: "Enviar enlace",
    backToLogin: "Volver a la conexión",
    emailSentTitle: "¡Email enviado!",
    resetEmailSentTo: "Se ha enviado un email de restablecimiento a:",
    checkInbox: "Revise su bandeja de entrada y haga clic en el enlace para restablecer la contraseña.",
    checkSpam: "Revise la carpeta de spam si no recibe el email.",
    forgotCodeTitle: "¿Código olvidado?",
    verification: "Verificación",
    codeRecovered: "¡Código recuperado!",
    enterEmail: "Introduzca su email",
    enterCodeReceived: "Introduzca el código recibido por email",
    yourAccessCodeDesc: "Aquí tiene su código de acceso",
    sendVerificationCode: "Enviar código de verificación",
    verifyCode: "Verificar código",
    newCodeSent: "¡Nuevo código enviado!",
    noEmailReceived: "¿No ha recibido el email?",
    changeEmail: "Cambiar email",
    resendCode: "Reenviar código",
    verificationSuccess: "¡Verificación correcta!",
    yourAccessCode: "Su código de acceso",
    connectNow: "Conectarse ahora",
    verificationCodeRequired: "Código de verificación requerido",
    devEmailNote: "En producción el email se envía por SMTP Supabase (Resend). En desarrollo contacte al administrador.",
    codeSentTo: "Se ha enviado un código de verificación a",
    codeGeneratedFor: "Código generado para",
    checkSpamFolder: "Revise la carpeta de correo no deseado si no lo recibe.",
  },
  access: {
    manageCodesPartners: "Gestionar códigos socios",
    manageCodesInstallers: "Gestionar códigos instaladores",
    manageCodesCommercials: "Gestionar códigos comerciales",
    createAccessCode: "Crear código de acceso",
    nameOrCompany: "Nombre / Empresa",
    codePlaceholder: "CÓDIGO",
    emailRequiredRecovery: "Email (REQUERIDO para recuperar código)",
    prefixTip: "Se añadirá automáticamente un prefijo único al código",
    emailTip: "El email se usa para enviar el código de verificación (gratis)",
    assignedRegionOptional: "Región asignada (opcional)",
    noRegion: "Ninguna región",
    add: "Añadir",
    save: "Guardar",
    cancel: "Cancelar",
    codeLabel: "Código:",
    noEmailImpossible: "Sin email (recuperación IMPOSIBLE)",
    edit: "Modificar",
    delete: "Eliminar",
    assignedRegion: "Región asignada",
    seePartnerOnJobs: "Ver socio en expedientes",
    partnerManageOwnSchedule: "Gestionar sus citas (fechas)",
    partnerManageOwnScheduleTooltip:
      "Si está activado, el socio puede definir o cambiar fecha y hora en sus propios expedientes pendientes o programados, y quitar la cita.",
    disablePartnerTooltip: "Desactivar: este instalador no verá al socio",
    enablePartnerTooltip: "Activar: este instalador verá al socio",
    codeCannotBeModified: "El código no puede modificarse por seguridad",
    emailRequired: "Email (REQUERIDO)",
  },
  settings: {
    title: "Cuenta",
    subtitle: "Perfil, seguridad y preferencias",
    sectionProfile: "Perfil",
    sectionSecurity: "Seguridad",
    sectionCompany: "Empresa",
    sectionIntegrations: "Integraciones",
    sectionData: "Datos",
    sectionNotifications: "Notificaciones",
    sectionSubscription: "Suscripción",
    sectionDanger: "Eliminar mi cuenta",
    language: "Idioma",
    languageDesc: "Interfaz en francés, inglés o español",
    profilePhoto: "Foto de perfil",
    profilePhotoDesc: "Personaliza tu avatar",
    change: "Cambiar",
    remove: "Eliminar",
    security: "Seguridad",
    password: "Contraseña",
    back: "Volver",
    data: "Datos",
    dataDesc: "Importar y exportar CSV o Excel",
    companyInfo: "Información de la empresa",
    companyInfoDesc: "Presupuestos y facturas",
    profilePhotoHint: "JPG, PNG, GIF · 2 MB máx.",
    apiKeys: "Claves API",
    apiKeysDesc: "Integraciones y acceso REST",
    createKey: "Crear clave",
    deleteKey: "Eliminar clave",
    docApi: "Documentación API (OpenAPI)",
    webhooks: "Webhooks",
    webhooksDesc: "Notificaciones HTTP (expedientes creados, modificados, terminados)",
    addWebhook: "Añadir webhook",
    active: "Activo",
    inactive: "Inactivo",
    enable: "Activar",
    disable: "Desactivar",
    newPassword: "Nueva contraseña",
    confirmPassword: "Confirmar",
    passwordUpdated: "Contraseña actualizada",
    changePasswordBtn: "Cambiar contraseña",
    changing: "Cambiando…",
    companyNameLabel: "Nombre de la empresa",
    companySiret: "SIRET",
    companyAddressLabel: "Dirección",
    companyPhoneLabel: "Teléfono",
    invoiceTemplateSection: "Presupuestos y facturas",
    invoiceTemplateDesc: "Personaliza el aspecto de tus PDFs de presupuestos y facturas.",
    myQuotes: "Mis presupuestos",
    myInvoices: "Mis facturas",
    matchWithQuote: "Vincular con presupuesto",
    matchWithQuoteHint: "Elige un expediente para reutilizar cliente y importe del presupuesto.",
    invoiceTemplateTheme: "Tema",
    invoiceTheme_minimal: "Minimal",
    invoiceTheme_minimal_desc: "Limpio, líneas finas, mucho espacio.",
    invoiceTheme_classic: "Clásico",
    invoiceTheme_classic_desc: "Bordes discretos, equilibrado.",
    invoiceTheme_luxe: "Lujo",
    invoiceTheme_luxe_desc: "Acento marcado, barra de título, premium.",
    invoiceTemplateAccentColor: "Color de acento",
    invoiceTemplateFooter: "Pie de página personalizado",
    invoiceTemplateFooterPlaceholder: "Dejar vacío para el texto por defecto. Ej.: Aviso legal, condiciones de pago…",
    invoiceTemplateScripts: "Scripts y textos",
    invoiceTemplateIntroText: "Texto de introducción",
    invoiceTemplateIntroPlaceholder: "Texto mostrado al inicio del documento (antes de Cliente / Fecha). Ej.: Objeto del servicio…",
    invoiceTemplateTermsText: "Condiciones / menciones",
    invoiceTemplateTermsPlaceholder: "Condiciones generales, plazo de pago, penalizaciones… (mostrado después del total).",
    invoiceTemplateLayout: "Maquetación",
    invoiceTemplatePageOrientation: "Orientación de la página",
    invoiceOrientation_portrait: "Vertical",
    invoiceOrientation_landscape: "Apaisado",
    invoiceTemplateFontSize: "Tamaño del texto",
    invoiceFontSize_small: "Pequeño",
    invoiceFontSize_normal: "Normal",
    invoiceFontSize_large: "Grande",
    invoiceTemplateLogoPosition: "Posición del logo",
    invoiceLogoPosition_left: "Izquierda",
    invoiceLogoPosition_right: "Derecha",
    invoiceTemplatePreview: "Vista previa",
    invoicePreviewCompany: "Mi empresa",
    invoiceTemplateAppearance: "Apariencia",
    invoiceTemplateLogo: "Logo en el documento",
    invoiceTemplateUseProfilePhoto: "Usar mi foto de perfil como logo",
    invoiceTemplateLogoOrDrop: "O suelta una imagen abajo (arrastrar y soltar) o pega una URL.",
    invoiceTemplateDropLogo: "Arrastra y suelta un logo o haz clic para elegir",
    invoiceTemplateLogoUrl: "URL del logo (opcional)",
    invoiceTemplateLogoHint: "URL pública de una imagen (PNG o JPG). Se muestra en el encabezado del documento.",
    saved: "Guardado",
    saving: "Guardando…",
    saveBtn: "Guardar",
    exportData: "Exportar sus datos",
    exportDataDesc: "Derecho a la portabilidad (RGPD) · ZIP con expedientes, stock, logs, etc.",
    downloadAll: "Descargar todo",
    generating: "Generando…",
    exportJobs: "Exportar expedientes",
    importJobs: "Importar expedientes",
    importJobsHint: "Archivo .xlsx, .xls o .csv",
    chooseFile: "Elegir archivo",
    download: "Descargar",
    notifications: "Notificaciones",
    notificationsDesc: "Activar o desactivar alertas",
    globalAlert: "Alerta global",
    globalAlertDesc: "Recibir notificaciones en la app (sin email)",
    newJobsNotif: "Nuevos expedientes",
    newJobsNotifDesc: "Ser notificado",
    miniSecretary: "Mini secretaria",
    miniSecretaryDesc: "Burbuja de notificación al entrar en el CRM",
    mySubscription: "Mi suscripción",
    billingPlan: "Facturación y plan",
    currentStatus: "Estado actual",
    manageSubscription: "Gestionar suscripción",
    security2FA: "Seguridad",
    security2FADesc: "Verificación en dos pasos",
    scanQR: "Escanee este código QR con su aplicación (Google Authenticator, Authy, etc.) e introduzca el código de 6 dígitos.",
    enterCode6: "Código de 6 dígitos",
    cancel: "Cancelar",
    validate: "Validar",
    verifying: "Verificando…",
    disable2FA: "Desactivar verificación en dos pasos",
    enable2FA: "Activar verificación en dos pasos",
    preparing: "Preparando…",
    dangerZone: "Zona de peligro",
    dangerZoneDesc: "Eliminar definitivamente la cuenta y todos los datos",
    deleteAccountWarn: "Esta acción elimina todo: expedientes, socios, instaladores, stock, regiones, historial, suscripción y su cuenta. Es irreversible.",
    deleteAccountBtn: "Eliminar mi cuenta",
    deleteAccountModalTitle: "Eliminar definitivamente la cuenta",
    deleteAccountModalDesc: "Escriba ELIMINAR para confirmar. Todos los datos serán eliminados.",
    deleteConfirmPlaceholder: "ELIMINAR",
    deleting: "Eliminando…",
    deletePermanently: "Eliminar definitivamente",
    newApiKey: "Nueva clave API",
    keyNameOptional: "Nombre (opcional)",
    keyNamePlaceholder: "Ej. Integración CRM",
    create: "Crear",
    keyCreated: "Clave creada",
    keySaveNotice: "Guarde esta clave: no se mostrará de nuevo.",
    copy: "Copiar",
    close: "Cerrar",
    newWebhook: "Nuevo webhook",
    webhookUrlLabel: "URL de recepción",
    webhookUrlPlaceholder: "https://su-servidor.com/webhook",
    webhookEventsLabel: "Eventos",
    webhookEventsHint: "Si no marca ninguno, se enviarán todos.",
    webhookSecret: "Secret del webhook",
    webhookSecretNotice: "Use este secret para verificar la firma (X-Webhook-Signature). No se mostrará de nuevo.",
    jobCreated: "Expediente creado",
    jobUpdated: "Expediente modificado",
    jobCompleted: "Expediente terminado",
    sessionExpired: "Sesión expirada. Reconéctese.",
    createKeyError: "Error al crear la clave",
    urlMustStart: "La URL debe comenzar por https:// o http://",
    passwordMinLength: "La contraseña debe tener al menos 6 caracteres",
    passwordMismatch: "Las contraseñas no coinciden",
    mfaScanSecret: "O introduzca este secret manualmente:",
    mfaInvalidCode: "Código inválido",
    mfaEnrollError: "Error al activar 2FA",
    mfaUnenrollError: "Error al desactivar 2FA",
    mfaEnterCode6: "Introduzca el código de 6 dígitos",
    mfaChallengeFail: "Desafío fallido",
    planTrialing: "Prueba gratuita",
    planActive: "Pro",
    planPastDue: "Pago atrasado",
    planCanceled: "Cancelado",
    planIncomplete: "Incompleto",
    csvClient: "Cliente",
    csvPhone: "Teléfono",
    csvAddress: "Dirección",
    csvStatus: "Estado",
    csvDate: "Fecha",
    csvTime: "Hora",
    csvSurface: "Superficie",
    csvLightingType: "Tipo de iluminación",
    csvCeilingHeight: "Altura techo",
    csvNotes: "Notas",
    csvCreatedAt: "Fecha de creación",
    statusPending: "Pendiente",
    statusScheduled: "Planificado",
    statusInProgress: "En curso",
    statusCompleted: "Terminado",
    statusCanceled: "Cancelado",
    noValidRows: "Ninguna fila válida (Cliente o Dirección requeridos).",
  },
  admin: {
    settings: "Cuenta",
    home: "Inicio",
    overview: "Resumen",
    jobs: "Expedientes",
    stock: "Stock",
    team: "Equipo",
    planning: "Planificación",
    regions: "Regiones",
    partners: "Socios",
    installers: "Instaladores",
    budget: "Presupuesto",
    access: "Acceso",
    workSection: "Trabajo",
    organizationSection: "Organización",
    logout: "Cerrar sesión",
    overviewCompleted: "Completados",
    overviewPending: "Pendientes",
    overviewTitle: "Panel",
    overviewSubtitle: "Acceso rápido a lo esencial de hoy.",
    overviewToSchedule: "Por programar",
    overviewToScheduleHint: "Pendientes o planificados",
    overviewInProgressHint: "Obras iniciadas",
    overviewDoneHint: "Cerrados o cancelados",
    overviewPlanningHint: "Calendario y citas",
    overviewLowStock: "Stock bajo",
    overviewLowStockHint: "referencia(s) bajo umbral",
    overviewLowStockOk: "Sin alertas",
    overviewRecentActivity: "Actividad reciente",
    overviewClear: "Borrar",
    overviewNoAccess:
      "No tiene acceso a ninguna sección en esta página. Use el menú según sus permisos.",
    jobsHubHint: "Elija una categoría para continuar.",
    statusPending: "Pendiente",
    statusScheduled: "Programado",
    statusInProgress: "En curso",
    statusCompleted: "Completado",
    statusCancelled: "Cancelado",
    jobsInProgress: "Trabajos en curso",
    noJobsInProgress: "Ningún trabajo en curso",
    client: "Cliente",
    address: "Dirección",
    phone: "Teléfono",
    region: "Región",
    installer: "Instalador",
    dateCreated: "Fecha creación",
    invoice: "Factura (€)",
    newJob: "Nuevo expediente",
    newShort: "Nuevo",
    add: "Añadir",
    addRegion: "Añadir región",
    addPartner: "Añadir socio",
    newPartner: "Nuevo socio",
    cancel: "Cancelar",
    save: "Guardar",
    edit: "Modificar",
    delete: "Eliminar",
    budgetPartners: "Presupuesto socios",
    seeDetail: "Ver detalle",
    noInvoiceYet: "Ninguna factura por ahora",
    jobsInvoiced: "expediente(s) facturado(s)",
    budgetJobsLine: "{{count}} expediente(s) facturado(s)",
    monthlyEvolution: "Evolución mensual (presupuesto)",
    revenueTitle: "Ingresos y facturación",
    caTotal: "Facturación total",
    caThisMonth: "Este mes",
    avgTicket: "Ticket medio",
    invoicesCount: "Facturas",
    trendLabel: "Tendencia vs mes ant.",
    caChartHint: "Facturación a partners (12 meses). El beneficio neto requiere costes de compra no registrados aquí.",
    stockByPartnerRegion: "Stock por socio y región",
    stockDescription: "El stock se gestiona por socio y región. Elija abajo para ver o modificar cantidades.",
    stockOf: "Stock de",
    reference: "Referencia",
    quantity: "Cantidad",
    installersInRegion: "Instaladores de la región",
    installersByRegion: "Instaladores por región. Haga clic en una región para ver todo.",
    regionLabel: "Región",
    installerLabel: "Instalador",
    noRegion: "Sin región",
    unassigned: "Sin asignar",
    searchPlaceholder: "Cliente, dirección, tel., instalador…",
    statusLabel: "Estado",
    typeLabel: "Tipo",
    filterStatus: "Estado:",
    filterRegion: "Región:",
    filterInstaller: "Instalador:",
    deleteRegionConfirm: "¿Eliminar la región « {{name}} »? El stock de esta región también se eliminará.",
    editRegion: "Modificar región",
    deleteRegion: "Eliminar región",
    editPartners: "Modificar socios",
    allRegions: "Todas las regiones",
    allPartners: "Todos los socios",
    allInstallers: "Todos los instaladores",
    allStatuses: "Todos los estados",
    allRegionsShort: "Todas regiones",
    filterPlanning: "Filtrar planificación",
    partnerLabel: "Socio",
    sortLabel: "Ordenar:",
    dateShort: "Fecha",
    searchLabel: "Búsqueda:",
    noRegionYet: "Ninguna región",
    addRegionsToSee: "Añada regiones para ver instaladores por región.",
    byRegion: "Por región",
    summaryOf: "Resumen de {{count}} expediente(s) mostrados (filtros y vista actuales).",
    jobSingular: "expediente",
    jobPlural: "expedientes",
    jobCount: "expediente(s)",
    noInvoiceInRegion: "Ninguna factura por ahora (los expedientes terminados y facturados aparecerán aquí).",
    regionDetailDesc: "Detalle de la región: stock, instaladores, socios, expedientes y facturas.",
    regionChooseDesc: "Elija una región para ver todo el detalle (stock, instaladores, socios, expedientes, facturas).",
    stockByRegionDesc: "Stock por región. Haga clic en una región para ver todo.",
    jobsTabLabel: "Expedientes",
    stocksTabLabel: "Stocks",
    installerCount: "instalador(es)",
    jobCountShort: "expediente(s)",
    newJobTitle: "Nuevo expediente (Admin)",
    assignInstaller: "Asignar instalador",
    assignCommercial: "Asignar comercial",
    assignToNobody: "Desasignar",
    chooseOption: "— Elegir —",
    fullAddressPlaceholder: "Dirección completa",
    clientNamePlaceholder: "Nombre del cliente",
    clientPhonePlaceholder: "Teléfono del cliente",
    stockRegionNote: "Región del instalador asignado.",
    stockRegionHouseLabel: "Región (base de stock)",
    mainRegionLabel: "Región principal",
    stockRegionsTitle: "Regiones de stock",
    actions: "Acciones",
    allFolder: "Todos",
    folderAdmin: "Admin",
    allJobsFolder: "Todos los expedientes",
    adminAndTeam: "Admin y equipo",
    adjustStock: "Ajustar stock",
    clearLabel: "Borrar",
    importButton: "Importar",
    importLoading: "Importando…",
    listView: "Lista",
    summaryView: "Resumen",
    budgetOverviewTab: "Vista general",
    budgetTariffsTab: "Tarifas",
    budgetInvoicesTab: "Facturas",
    totalInvoiced: "Total facturado",
    invoicesInRegion: "Facturas de la región",
    partnersInRegion: "Socios de la región",
    editTariff: "Modificar tarifa",
    budgetIntro: "Los importes de facturación a socios se calculan con las tarifas por socio, región y tipo de expediente (pestaña Tarifas). Consulte la pestaña Facturas para el detalle por socio y expediente.",
    editReference: "Modificar referencia",
    editJob: "Modificar expediente",
    viewJob: "Consultar expediente",
    viewOnlyNoEdit: "Solo consulta — no tienes permiso para modificar este expediente",
    openDossier: "Abrir expediente",
    editReport: "Modificar informe",
    closeJob: "Cerrar expediente",
    addStockUnit: "Añadir unidad",
    manageInstallers: "Gestionar instaladores",
    statusCancelledClient: "Cancelado (cliente)",
    deleteRegionShortConfirm: "¿Eliminar esta región? El stock asociado también se eliminará.",
    editOrDeleteRegion: "Modificar o eliminar esta región",
    history: "Historial",
    jobsInvoicedCount: "Expedientes facturados",
    recalculateInvoices: "Recalcular facturas",
    recalculateLoading: "Recalculando…",
    tariffGrid: "Cuadro de tarifas",
    regieAdmin: "Regie Admin",
    loading: "Cargando…",
    internalStock: "Stock interno",
    noRecentActivity: "Ninguna actividad reciente.",
    partnerPlaceholder: "Socio…",
    perPage: "Por página",
    goTo: "Ir a",
    noJobs: "Ningún expediente",
    noInstallerInRegion: "Ningún instalador asignado en esta región.",
    newRegion: "Nueva región",
    addRegionShort: "Añadir región",
    noRegionHere: "Ninguna región",
    alertLabel: "Alerta",
    noStockInRegion: "Ningún artículo en stock en esta región.",
    noInstallerWithJobInRegion: "Ningún instalador con expediente en esta región.",
    amount: "Importe",
    partnersTitle: "Socios",
    choosePartnerDesc: "Elija un socio para ver sus expedientes por región.",
    chooseInstallerDesc: "Haga clic en un instalador para ver todos sus expedientes asignados.",
    noPartnerInRegion: "Ningún socio con expediente en esta región.",
    noInstallerHere: "Ningún instalador",
    addInstallersInAccess: "Añada instaladores en Gestión de acceso.",
    allInstallersTitle: "Todos los instaladores",
    loadingTariffs: "Cargando tarifas…",
    chooseRegionOption: "Elegir una región",
    newPrice: "Nuevo (€)",
    replacementPrice: "Sustitución (€)",
    chooseReferenceOption: "Elegir una referencia",
    newLabel: "Nuevo",
    replacementLabel: "Sustitución",
    unitPrice: "Precio unitario (€)",
    byPartner: "Por socio",
    totalInvoicesByPartner: "Total facturas (expedientes terminados) por socio.",
    invoiceDetail: "Detalle de facturas",
    noJobWithPartner: "Ningún expediente terminado con socio.",
    seeStockOf: "Ver stock de:",
    choosePartnerOption: "Elegir un socio…",
    noReferenceForPartner: "Ninguna referencia para este socio.",
    nameQtyAlert: "Nombre, cantidad y umbral de alerta.",
    detailsAndPlanning: "Detalles y planificación",
    jobTypeLabel: "Tipo de expediente",
    led: "LED",
    dehumidifier: "Deshumidificador",
    nameOrFirstName: "Nombre / Apellidos",
    jobCancelledByClient: "Expediente cancelado por el cliente.",
    technicalVisit: "Visita técnica",
    installation: "Instalación",
    quantitiesPlaced: "Cantidades instaladas (nuevo / sustitución) y comentario",
    createJobDesc: "Crear expediente y opcionalmente asignarlo a un equipo",
    contextStockUsed: "Contexto: stock utilizado",
    businessBringer: "Portador de negocio",
    noPartnerInternal: "Sin socio (stock interno)",
    chooseRegionDot: "Elegir una región...",
    clientAndTech: "Cliente y técnico",
    typeDot: "Tipo...",
    notesLabel: "Notas",
    chooseTeam: "Elegir un equipo...",
    chooseJobTypeAlert: "Elija el tipo de expediente (LED exterior, LED interior, Deshumidificador, VMC Agricoles, TH 122 o Renovación).",
    errorAiSearch: "Error búsqueda IA",
    errorAiSuggest: "Error sugerencia IA",
    errorAiStock: "Error sugerencia stock",
    noItemInRegion: "Ningún artículo en esta región",
    noValidRowImport: "Ninguna línea válida (Cliente o Dirección requeridos).",
    errorImport: "Error al importar.",
    readFileError: "No se pudo leer el archivo",
    invoiceLabel: "Factura:",
    partnerInvoiceLabel: "Factura socio:",
  },
  partner: {
    deleteJob: "Eliminar expediente",
    deleteJobConfirm: "¿Eliminar este expediente? Esta acción es irreversible.",
    deleteJobError: "No se puede eliminar el expediente.",
  },
  installer: {
    history: "Historial",
    myDay: "Mi día",
    myDossiers: "Mis expedientes",
    nothingToday: "Nada previsto hoy",
    jobs: "Expedientes",
    planning: "Planificación",
    menu: "Menú",
    close: "Cerrar",
    spaceTitle: "Espacio Instalador",
    date: "Fecha",
    time: "Hora",
    appointmentDate: "Fecha de la cita",
    appointmentTime: "Hora de la cita",
    tapToEdit: "Pulse para modificar",
    imGoing: "VOY",
    call: "LLAMAR",
    noPhone: "Número no indicado",
    materialUsed: "¿Material utilizado?",
    new: "Nuevo",
    replacement: "Sustitución",
    validationSuccess: "Expediente validado.",
    validationInHistory: "Ya está en su historial.",
    jobsInProgress: "Expedientes en curso",
    noJobsInProgress: "Ningún expediente en curso",
    viewOnlyInProgress: "En curso — solo consulta",
  },
  signedQuote: {
    title: "Documentos",
    loading: "Cargando archivo…",
    loadError: "No se puede mostrar el documento. Vuelva a iniciar sesión o contacte al administrador.",
    invalidPath: "Ruta de archivo no válida.",
    previewAlt: "Vista previa del documento",
    openPdf: "Abrir PDF",
    openImage: "Abrir imagen",
    delete: "Eliminar",
    deleteConfirm: "¿Eliminar este documento? Esta acción no se puede deshacer.",
    deleteError: "No se puede eliminar el archivo.",
    fileTypesHint: "PDF o foto (JPEG, PNG, WebP) — máx. {{maxMb}} Mo por archivo",
    tapToUpload: "Tocar para añadir foto(s) o PDF",
    uploading: "Enviando…",
    replaceFile: "Reemplazar el archivo existente (opcional)",
    addMore: "Añadir un documento",
    addMoreHint: "Puede añadir varios archivos",
    uploadSuccess: "Documento guardado correctamente",
  },
  commercial: {
    appTitle: "Espacio comercial",
    planningOnly: "Planning",
    logout: "Cerrar sesión",
    noAppointments: "Sin citas programadas",
    noAppointmentsHint: "Su administrador debe asignarle expedientes con fecha.",
    backToPlanning: "Volver al planning",
    appointment: "Cita",
    date: "Fecha",
    time: "Hora",
    openMaps: "Google Maps",
    address: "Dirección",
    partnerRemarks: "Observaciones del socio (expediente)",
  },
  common: {
    settings: "Cuenta",
    logout: "Cerrar sesión",
    appearance: "Apariencia",
    themeSystem: "Sistema",
    themeLight: "Claro",
    themeDark: "Oscuro",
    roleOwner: "Propietario",
    roleAdmin: "Administrador",
    rolePartner: "Socio",
    roleInstaller: "Instalador",
    roleCommercial: "Comercial",
    langFr: "Français",
    langEn: "English",
    langEs: "Español",
  },
} as const;
